
import { Observer } from 'mobx-vue'
import { Vue, Component } from 'vue-property-decorator'
import OrderItemScript from './script'
import OrderBtns from '../btns/btns.vue'
import GroupBuy from '../groupbuy/groupbuy.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import OrderDescPopup from '@xt/www/components/orderDesc/index.vue'
import Teleport from '@xt/client/mixins/components/teleport.vue'

@Observer
@Component({
  name: 'OrderItemComp',
  components: {
    OrderBtns,
    GroupBuy,
    LazyImg,
    OrderDescPopup,
    Teleport
  }
})
export default class OrderItemComp extends OrderItemScript {}
